import { tasksScenarios } from './steps'
import { tasksTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const tasksOnboarding: IOnboardingModule = {
  scenarios: tasksScenarios,
  texts: tasksTexts,
  conditions: {},
}
